module.exports = __webpack_public_path__ + "img/up.b6fb4e57.svg";